module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pop"
    }
  }, [(_vm.openPop) ? _c('Popup', {
    on: {
      "close": function($event) {
        _vm.openPop = false
      }
    }
  }, [_c('div', {
    staticClass: "p-3",
    attrs: {
      "slot": "table"
    },
    slot: "table"
  }, [(_vm.recognizeData) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "55vh"
    },
    attrs: {
      "id": "style-1"
    }
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('learning_contents')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('last_update_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('play')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('download')))])])]), _vm._v(" "), _vm._l((_vm.recognizeData), function(item, index) {
    return _c('tbody', {
      key: index,
      staticStyle: {
        "border-top": "1px #cccccc solid",
        "text-align": "left"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("\n                " + _vm._s(item.sentence) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.createTime ? item.createTime : '─ ─ ─ ─ / ─ ─ / ─ ─') + "\n              ")]), _vm._v(" "), _c('td', [(!item.voiceUrl) ? _c('a', {
      staticClass: "disabled",
      on: {
        "click": function($event) {
          return _vm.playAudio(item.voiceUrl)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('play')) + "\n                ")]) : _c('a', {
      staticClass: "pointer hasLink",
      on: {
        "click": function($event) {
          return _vm.playAudio(item.voiceUrl)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('play')) + "\n                ")])]), _vm._v(" "), _c('td', [(!item.voiceUrl) ? _c('a', {
      attrs: {
        "download": "",
        "target": "_blank",
        "href": item.voiceUrl
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('download')) + "\n                ")]) : _c('a', {
      staticClass: "hasLink",
      attrs: {
        "download": "",
        "target": "_blank",
        "href": item.voiceUrl
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('download')) + "\n                ")])])])])
  })], 2), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.voiceUrl,
      "type": "audio/ogg"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('label-tag', {
    attrs: {
      "tagArray": ['學習點', '任務']
    }
  }), _vm._v(" "), (this.userInfo) ? _c('div', {
    staticClass: "recordInfo",
    staticStyle: {
      "weight": "100%"
    }
  }, [_c('h3', {
    staticClass: "p-0 mb-3"
  }, [_vm._v("\n      " + _vm._s(this.userInfo.realName) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "p-0 ml-3"
  }, [_vm._v("\n      目前累積學習時間: " + _vm._s(this.userInfo.spendTime) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "p-0 ml-3"
  }, [_vm._v("\n      目前累積總星星數: " + _vm._s(this.userInfo.starCount) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-5 table-responsive",
    staticStyle: {
      "overflow": "auto",
      "min-height": "50vh",
      "font-size": "1.25rem"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            中文標題\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            星星數\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('study_time')) + "\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n            " + _vm._s(_vm.$t('oral_practice')) + "\n          ")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.record.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.starCount) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")]), _vm._v(" "), _c('td', [(item.hasRecognize) ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.goInfo(item.lessonId)
        }
      }
    }, [_vm._v("\n              detail\n            ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.record.pageIndex,
      "total": _vm.record.pgeCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54c7b556!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/record/RecordPersonalInfo.vue
// module id = 786
// module chunks = 3